import { DatabaseCheckIcon } from './DatabaseCheckIcon';

/**
 * author: Andrew Nenakhov
 * id C241F52F-EA70-4784-9455-AA7D05663C90
 * name database-check
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/database-check.svg
 * tags
 * - Geographic Information System 
 * - Database 
 */
export const DatabaseTickIcon = DatabaseCheckIcon;
export default DatabaseTickIcon